/**
 * Gallery images inside page blocks (same COVERS bucket).
 */
import type { CoverExt } from "./quest-cover.ts";
import { COVER_CONTENT_TYPE } from "./quest-cover.ts";

const FILE = /^([0-9a-f]{32})\.(webp|jpg)$/;

/** R2 key: gallery-photos/<missionId>/<blockSlot>/<itemIndex>/<hash>.webp */
export function galleryPhotoKey(
  missionId: string,
  blockSlot: number,
  itemIndex: number,
  hash: string,
  ext: CoverExt,
): string {
  return `gallery-photos/${missionId}/${blockSlot}/${itemIndex}/${hash}.${ext}`;
}

export function galleryPhotoUrl(
  missionId: string,
  blockSlot: number,
  itemIndex: number,
  key: string | null | undefined,
): string | null {
  if (!key) return null;
  const prefix = `gallery-photos/${missionId}/${blockSlot}/${itemIndex}/`;
  if (!key.startsWith(prefix)) return null;
  const file = key.slice(prefix.length);
  if (!FILE.test(file)) return null;
  return `/api/gallery-photos/${encodeURIComponent(missionId)}/${blockSlot}/${itemIndex}/${file}`;
}

export function parseGalleryPhotoFile(file: string): { hash: string; ext: CoverExt } | null {
  const m = FILE.exec(file);
  return m ? { hash: m[1]!, ext: m[2] as CoverExt } : null;
}

export { COVER_CONTENT_TYPE as GALLERY_PHOTO_CONTENT_TYPE };

export const MAX_GALLERY_ITEMS = 12;
export const MAX_GALLERY_CAPTION = 500;
